export default {
  aboutUs: {
    en: '/about-us',
    es: '/es/sobre-nosotros',
    it: '/it/chi-siamo',
    fr: '/fr/a-propos-de-nous',
    de: '/de/uber-uns',
    tr: '/tr/hakkimizda',
    pl: '/pl/o-nas',
    pt: '/pt/sobre-nos',
    cn: '/cn/about-us'
  },
  collaborators: {
    en: '/collaborators',
    es: '/es/collaborators',
    it: '/it/collaborators',
    fr: '/fr/collaborators',
    de: '/de/collaborators',
    tr: '/tr/collaborators',
    pl: '/pl/collaborators',
    pt: '/pt/collaborators',
    cn: '/cn/collaborators'
  },
  becomePartner: {
    en: '/become-a-partner-of-spotahome',
    es: '/es/become-a-partner-of-spotahome',
    it: '/it/become-a-partner-of-spotahome',
    fr: '/fr/become-a-partner-of-spotahome',
    de: '/de/become-a-partner-of-spotahome',
    tr: '/tr/become-a-partner-of-spotahome',
    pl: '/pl/become-a-partner-of-spotahome',
    pt: '/pt/become-a-partner-of-spotahome',
    cn: '/cn/become-a-partner-of-spotahome'
  },
  institutions: {
    en: '/institutions',
    es: '/es/institutions',
    it: '/it/institutions',
    fr: '/fr/institutions',
    de: '/de/institutions',
    tr: '/tr/institutions',
    pl: '/pl/institutions',
    pt: '/pt/institutions',
    cn: '/cn/institutions'
  },
  workWithUs: {
    en: '/work-with-us',
    es: '/es/work-with-us',
    it: '/it/work-with-us',
    fr: '/fr/work-with-us',
    de: '/de/work-with-us',
    tr: '/tr/work-with-us',
    pl: '/pl/work-with-us',
    pt: '/pt/work-with-us',
    cn: '/cn/work-with-us'
  },
  howItWorks: {
    en: '/how-it-works',
    es: '/es/como-funciona',
    it: '/it/come-funziona',
    fr: '/fr/comment-fonctionne',
    de: '/de/wie-es-funktioniert',
    tr: '/tr/nasil-calisiyor',
    pl: '/pl/jak-to-dziala',
    pt: '/pt/como-funciona',
    cn: '/cn/how-it-works'
  },
  internships: {
    en: '/internships',
    es: '/es/internships',
    it: '/it/internships',
    fr: '/fr/internships',
    de: '/de/internships',
    tr: '/tr/internships',
    pl: '/pl/internships',
    pt: '/pt/work-with-us',
    cn: '/cn/internships'
  },
  studentAmbassador: {
    en: 'https://rent.spotahome.com/become-a-spotahome-ambassador',
    es: 'https://rent.spotahome.com/become-a-spotahome-ambassador',
    it: 'https://rent.spotahome.com/become-a-spotahome-ambassador',
    fr: 'https://rent.spotahome.com/become-a-spotahome-ambassador',
    de: 'https://rent.spotahome.com/become-a-spotahome-ambassador',
    tr: 'https://rent.spotahome.com/become-a-spotahome-ambassador',
    pl: 'https://rent.spotahome.com/become-a-spotahome-ambassador',
    pt: 'https://rent.spotahome.com/become-a-spotahome-ambassador',
    cn: 'https://rent.spotahome.com/become-a-spotahome-ambassador'
  },
  termsAndConditions: {
    en: '/terms-and-conditions',
    es: '/es/terminos-y-condiciones',
    it: '/it/termini-e-condizioni',
    fr: '/fr/termes-et-conditions',
    de: '/de/geschaftsbedingungen',
    tr: '/tr/sartlar-ve-kosullar',
    pl: '/terms-and-conditions',
    pt: '/terms-and-conditions',
    cn: '/cn/terms-and-conditions'
  },
  companyDetails: {
    en: '/company-details',
    es: '/es/datos-empresa',
    it: '/it/informazioni-di-contatto',
    fr: '/fr/coordonnees-entreprise',
    de: '/de/impressum ',
    pt: '/pt/detalhes-empresa',
    pl: '/company-details',
    tr: '/company-details',
    cn: '/company-details'
  },
  cookiesPolicy: {
    en: '/cookies-policy',
    es: '/es/politica-cookies',
    it: '/it/cookies-policy',
    fr: '/fr/cookies-policy',
    de: '/de/cookies-policy',
    tr: '/tr/cookies-policy',
    pl: '/pl/cookies-policy',
    pt: '/pt/cookies-policy',
    cn: '/cn/cookies-policy'
  },
  privacyPolicies: {
    en: '/privacy-policies',
    es: '/es/politica-privacidad',
    it: '/it/privacy-policies',
    fr: '/fr/privacy-policies',
    de: '/de/privacy-policies',
    tr: '/tr/privacy-policies',
    pl: '/pl/privacy-policies',
    pt: '/pt/privacy-policies',
    cn: '/cn/privacy-policies'
  },
  sitemap: {
    en: '/sitemap',
    es: '/es/sitemap',
    it: '/it/sitemap',
    fr: '/fr/sitemap',
    de: '/de/sitemap',
    tr: '/tr/sitemap',
    pl: '/pl/sitemap',
    pt: '/pt/sitemap',
    cn: '/cn/sitemap'
  },
  blog: {
    en: '/blog/',
    es: '/es/blog/',
    it: '/blog/',
    fr: '/fr/blog/',
    de: '/de/blog/',
    tr: '/blog/',
    pl: '/blog/',
    pt: '/blog/',
    cn: '/cn/blog/'
  },
  help: {
    de: 'https://help.spotahome.com/hc/de',
    es: 'https://help.spotahome.com/hc/es',
    fr: 'https://help.spotahome.com/hc/fr',
    it: 'https://help.spotahome.com/hc/it',
    en: 'https://help.spotahome.com/hc/en-us',
    tr: 'https://help.spotahome.com/hc/en-us',
    pl: 'https://help.spotahome.com/hc/en-us',
    pt: 'https://help.spotahome.com/hc/pt',
    cn: 'https://help.spotahome.com/hc/en-us'
  },
  promotions: {
    en: '/promotions',
    es: '/es/promotions',
    it: '/it/promotions',
    fr: '/fr/promotions',
    de: '/de/promotions',
    tr: '/tr/promotions',
    pl: '/pl/promotions',
    pt: '/pt/promotions',
    cn: '/cn/promotions'
  },
  contactUs: {
    en: '/contact-us',
    es: '/es/contacto',
    it: '/it/contattaci',
    fr: '/fr/nous-contacter',
    de: '/de/kontaktieren-sie-uns',
    tr: '/tr/bize-ulasin',
    pl: '/pl/skontaktuj-sie-z-nami',
    pt: '/pt/contacte-nos',
    cn: '/cn/contact-us'
  },
  publishYourProperty: {
    en: '/landlords',
    es: '/es/propietarios',
    it: '/it/proprietari',
    fr: '/fr/proprietaires',
    de: '/de/fuer-den-vermieter',
    tr: '/tr/ev-sahipleri',
    pl: '/pl/wlasciciele',
    pt: '/pt/publique-a-sua-propriedade',
    cn: '/list-your-property'
  }
};
